module.exports = __webpack_public_path__ + "static/img/IMG_20240209_162239.804b791c.jpg";